module.exports = __webpack_public_path__ + "img/whiteBlueUp.782c5976.svg";